var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"margin":"0"},attrs:{"dir":"rtl"}},[_c('b',[_vm._v("זמן שיחה:")]),_vm._v(" "+_vm._s(_vm.timer))])
}
var staticRenderFns = []

export { render, staticRenderFns }